import { emitChange, getState, setState, syntheticEvent } from './helpers';
/** Attach document-level pointer tracking for slider-style drag. */
export function wirePointerDrag(node, onDrag, onEnd) {
    node.on('mousedown', function (event) {
        var app = node.getApp();
        if (!app)
            return;
        var el = app['renderer'].getElement();
        var move = function (e) {
            var rect = el.getBoundingClientRect();
            var me = e;
            var x = me.clientX - rect.left;
            var y = me.clientY - rect.top;
            var world = app.camera.screenToWorld(x, y);
            onDrag(world.x, world.y, event, me);
        };
        var up = function () {
            el.removeEventListener('mousemove', move);
            el.removeEventListener('mouseup', up);
            el.removeEventListener('mouseleave', up);
            onEnd === null || onEnd === void 0 ? void 0 : onEnd();
        };
        el.addEventListener('mousemove', move);
        el.addEventListener('mouseup', up);
        el.addEventListener('mouseleave', up);
        var startPtr = event.originalEvent;
        onDrag(event.worldX, event.worldY, event, startPtr);
    });
}
export function wireToggle(node, field, updateVisual) {
    var toggle = function () {
        var _a;
        var current = Boolean(getState(node)[field]);
        var next = !current;
        setState(node, (_a = {}, _a[field] = next, _a));
        if (field === 'checked' || field === 'value') {
            node.ariaChecked = next;
        }
        updateVisual(next);
        emitChange(node, next, field);
    };
    node.on('click', toggle);
}
export function wireButtonStates(node, updateVisual) {
    var refresh = function (hover, active) {
        var disabled = Boolean(getState(node).disabled);
        updateVisual({ hover: hover, active: active, disabled: disabled });
    };
    node.on('mouseenter', function () { return refresh(true, false); });
    node.on('mouseleave', function () { return refresh(false, false); });
    node.on('mousedown', function () { return refresh(true, true); });
    node.on('mouseup', function () { return refresh(true, false); });
    node.on('click', function (e) {
        if (getState(node).disabled) {
            e.stopPropagation();
        }
    });
    refresh(false, false);
}
export function wireSelectFromList(node, items, field, updateVisual) {
    node.on('click', function (event) {
        var _a;
        var bounds = node.getBounds();
        var localY = event.worldY - node.y;
        var rowHeight = bounds.height / Math.max(items.length, 1);
        var index = Math.floor(localY / rowHeight);
        if (index >= 0 && index < items.length) {
            setState(node, (_a = {}, _a[field] = index, _a.selectedIndex = index, _a.selectedItem = items[index], _a));
            updateVisual(index);
            emitChange(node, items[index], field);
            node.emit('select', syntheticEvent('select', node, { index: index, item: items[index] }));
        }
    });
}
export function scheduleAutoDismiss(node, ms, onDismiss) {
    var id = window.setTimeout(function () {
        var _a;
        onDismiss();
        node.emit('close', syntheticEvent('close', node));
        (_a = node.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
    }, ms);
    node.metadata._dismissTimer = id;
}
export function clearAutoDismiss(node) {
    var id = node.metadata._dismissTimer;
    if (id !== undefined) {
        clearTimeout(id);
        delete node.metadata._dismissTimer;
    }
}
export function trapFocusIn(group) {
    var focusables = group.children.filter(function (c) { return c.focusable; });
    if (focusables.length === 0)
        return;
    var app = group.getApp();
    app === null || app === void 0 ? void 0 : app.focusNode(focusables[0]);
}
